import { format as Format } from 'date-fns';

export const dateFormat = (date, format = 'MM/dd/yyyy') => {
    return Format(new Date(date), format);
};